module.exports = __webpack_public_path__ + "media/images/icon-baby-d24130ed78e630904eedd0920bc3c009.svg";